<template>
  <div class="select-inner">
    <div class="select-title">
      <h6>{{$t('cite-Source')}}</h6>
      <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 10 10">
        <g>
          <path fill="none" d="M0 0H10V10H0z" transform="translate(-750 -400) translate(750 400)"/>
          <path fill="#2659a8" d="M5.673 4.714l-3.242 5.414a.766.766 0 0 0 .655 1.149h6.485a.766.766 0 0 0 .655-1.149L6.983 4.714a.766.766 0 0 0-1.309 0z" transform="translate(-750 -400) rotate(90 182.302 580.975)"/>
        </g>
      </svg>
    </div>

    <div class="select-list">
      <ul class="types">
        <li class="item" v-for="val in cite_types">
          <button class="wv-btn" type="button" v-on:click="changeSource(val.value)" v-bind:class="{ 'active': (selectSource === val.value) }">{{ $t(`source-${val.text}`) }}</button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectSource",
  props: ["currentStyle", "selectStyle", "selectSource"],
  data: function() {
    return {
      cite_types : [
        { text: 'Website', value: 'webpage', class:''},
        { text: 'Journal Article', value: 'article-journal', class:''},
        { text: 'Book', value: 'book', class:''},
      ],
    }
  },
  methods: {
    changeSource(source) {
      this.$emit("changeSource", source)
    }
  }
}
</script>

<style scoped>
.select-list {
  width: 100%;
}

.types {
  display: flex;
  gap: 1rem;
}

.types .item {
  flex: 1;
  margin: 0 !important;
}

.types .item button {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/generator/SelectSource.vue